import React, { useEffect, useState, useContext } from 'react';
import '../styles/Header.scss';
import logo from '../assets/images/logo.png';
import { HashLink } from 'react-router-hash-link';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import HeaderNewsTicker from './HeaderNewsTicker';

const Header = () => {  
  const { user } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/signin');
  };

  const goToProfile = () => {
    navigate('/profile');
  };

  return (
    <div>
    <header className="moviepro-header navbar navbar-expand-lg">
      <div className="container-fluid d-flex align-items-center flex-wrap justify-content-between">
        {/* Logo */}
        <div className="d-flex align-items-center">
          <span className="navbar-brand d-flex align-items-center mb-0 h1">
            <HashLink to="/#home">
              <img src={logo} alt="Movie Pro Logo" className="logo-icon me-2" />
            </HashLink>
          </span>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="navbar-toggler d-lg-none border-0"
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className="fa-solid fa-bars text-white fs-4"></i>
        </button>

        {/* Nav links */}
        <div className={`collapse navbar-collapse ${menuOpen ? 'show' : ''}`}>
          <nav className="main-nav navbar-nav me-auto mb-2 mb-lg-0">
            <HashLink smooth to="/#upcoming-movies" className="nav-link" onClick={() => setMenuOpen(false)}>
              MOVIE
            </HashLink>
            <HashLink smooth to="/#video-photos" className="nav-link" onClick={() => setMenuOpen(false)}>
              GALLERY
            </HashLink>
            <HashLink smooth to="/#latest-news" className="nav-link" onClick={() => setMenuOpen(false)}>
              NEWS
            </HashLink>
            <HashLink smooth to="/#featured-events" className="nav-link" onClick={() => setMenuOpen(false)}>
              EVENTS
            </HashLink>
            <HashLink smooth to="/contact-us" className="nav-link" onClick={() => setMenuOpen(false)}>
              CONTACT
            </HashLink>
          </nav>

          {/* Right-side: Search + Profile/Signup */}
          <div className="header-right d-flex align-items-center gap-3 flex-wrap mt-3 mt-lg-0">
            {/* <form className="search-bar d-flex">
              <select className="search-type form-select me-2">
                <option>All Categories</option>
                <option>Movie</option>
                <option>Theater</option>
              </select>
              <input
                type="text"
                className="search-input form-control me-2"
                placeholder="Search Movie, Theater"
              />
              <button className="search-btn btn btn-danger" type="submit">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form> */}

            {user.isAuthenticated ? (
              <><p style={{marginBottom: "3px"}}>Hi, {user.name}</p>
              <button className="btn btn-outline-light profile-icon" onClick={goToProfile}>
                <i className="fa-solid fa-user-circle fs-4"></i>
              </button></>
            ) : (
              <button className="signup-btn btn btn-danger" onClick={handleSignUp}>
                Register/Login
              </button>
            )}
          </div>
        </div>
      </div>
      
    </header>
    <HeaderNewsTicker />
    </div>
  );
};

export default Header;